<template>
    <div class="position-box security">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="link" @click="jump">{{$t('mbwt.tg')}}</div>
        </div>
        <div class="cotainer" :class="{mn: lang == 'ar'}">
           <div class="security-tips">{{$t('mbwt.title')}}</div>
            <div class="select-box mt15" @click.stop="down" v-if="lang =='ar'">
                <img class="arrow" src="@/assets/down.png" alt="">
                <input class="section1-right section-type" type="text" disabled v-model="curWt">
            </div>
            <div class="select-box mt15" @click.stop="down" v-else>
                <input class="section1-right section-type" type="text" disabled v-model="curWt">
                <img class="arrow" src="@/assets/down.png" alt="">
            </div>
            <div class="mt20"><input id="idCard" class="section1-right" v-model="answer" :placeholder="$t('mbwt.qtxda')" /></div>
            <div class="tips-box">
                <!-- <div class="tips"></div> -->
                <div class="tips-text">{{$t('mbwt.zyts')}}{{$t('mbwt.zytsCont')}}</div>
            </div>
            <div class="btn-box">
                <button type="button" class="btn-submit btn-bg" @click="submit">{{$t('mbwt.tj')}}</button>
            </div>
        </div>
        <div class="mask" v-show="isDown" @click="down"></div>
        <ul class="ul-box" v-show="isDown">
            <li class="list" v-for="(item,index) in wtArr" @click.stop="select(item.id,item[lang])" :key="index">{{item[lang]}}</li>
        </ul>
    </div>
</template>

<script>
import {newLang} from '../utils/problem.js'
export default {
    name: 'security',
    data () {
        return {
            theme: false,
            lang: 'en',
            token: '',
            wtId: 1,
            curWt: '',
            wtArr: [],
            answer: '',
            isDown: false,
        }
    },
    created(){
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.lang = localStorage.getItem('language') || 'en';
        this.wtArr = newLang.problem;
        this.curWt = this.wtArr[0][this.lang];
        this.token = localStorage.getItem('token');
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        jump(){
          if(this.token){
            this.$router.push('/securityCenter')
          }else{
            this.$router.push('/login')
          }
        },
        submit(){
            var params = {
                token: this.token,
                sec_question: this.curWt,
                sec_answer: this.answer
            }
            if(!this.answer || this.answer == null){
                this.$toast.center(this.$t('mbwt.qtxda'));
                return;
            }
            this.$ajax.get('/web/setSecQuestion',{params}).then((res) => {
                let resData = res.data.data;
                setTimeout(() => {
                  if(this.token){
                    this.$router.push('/securityCenter')
                  }else{
                    this.$router.push('/login')
                  }
                }, 1000)
            }).catch(function(err){
                console.log(err)
            })
        },
        down(){
            this.isDown = !this.isDown;
        },
        select(id,title){
            this.wtId = id;
            this.curWt = title;
            this.isDown = false;
        }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .link{
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 1.6rem;
        bottom: 2rem;
        background: #fff;
        overflow-y: scroll;
    }
    .security input::-webkit-input-placeholder {
        color: #666;
        font-size: .36rem;
    }
    .security-tips {
        display: flex;
        align-items: center;
        margin: .45rem 0 .9rem;
        color: #666;
        font-size: .54rem;
        font-weight: bold;
        line-height: .6rem;
    }
    .select-box{
        position: relative;
        flex: 1;
    }
    .ul-box{
        position: absolute;
        bottom: 0;
        left: -1px;
        right: 0;
        z-index: 1000;
        /* border: 1px solid #b3b3b3; */
        /* border-radius: .18rem; */
        background: #fff;
        box-sizing: border-box;
    }
   .ul-box .list{
        height: 1.2rem;
        font-size: .42rem;
        line-height: 1.2rem;
        border-bottom: 1px solid #b3b3b3;
        text-align: center;
    }
    .ul-box .list:last-child{
        border-bottom: none;
    }
    .select-box .arrow{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .54rem;
        margin-top: -.18rem;
    }
    .mn .select-box .arrow{
      left: .3rem;
      right: .3rem;
    }
    .section1-right {
        width: 100%;
        height: 1.26rem;
        font-size: .4rem;
        line-height: 1.26rem;
        color: #000;
        border-radius: .18rem;
        background: #f8f8f8;
        box-sizing: border-box;
        text-indent: .18rem;
    }
    .section1-right.section-type{
        padding-right: 1.2rem;
        border-radius: .18rem;
    }
    .mn .section1-right.section-type{
      padding-left: 1rem;
      padding-right: 0;
    }
    .btn-submit {
        display: block;
        width: 100%;
    }
    .btn-box{
        position: fixed;
        left: 0;
        bottom: .75rem;
        width: 100%;
        padding: 0 .45rem;
        box-sizing: border-box;
    }
    .tips-box .tips{
        color: #666;
        padding: .6rem 0 .15rem;
    }
    .tips-box .tips-text{
        padding: .6rem 0;
        color: #000;
        font-size: .36rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/security.vue